import { ValidationResult, RequiredFieldCheck } from '@/views/helpers/validation-result';
import DisabilityRate from '@/views/validations/disability-rate';

export default {
  validate (uwvDecision) {
    let validationResult = new ValidationResult();

    validationResult.push(DisabilityRate.validateDisabilityRateFormat(uwvDecision.disabilityRate));
    validationResult.push(DisabilityRate.validateDisabilityRateMinimum(uwvDecision.disabilityRate));
    validationResult.push(DisabilityRate.validateDisabilityRateMaximum(uwvDecision.disabilityRate));

    return validationResult;
  },

  requiredFields (uwvDecision) {
    let validationResult = new ValidationResult();

    validationResult.push(RequiredFieldCheck('startDate', uwvDecision.startDate));
    validationResult.push(RequiredFieldCheck('disabilityRate', uwvDecision.disabilityRate));
    validationResult.push(RequiredFieldCheck('decisionType', uwvDecision.decisionType));
    validationResult.push(RequiredFieldCheck('attachments', uwvDecision.attachments));
    validationResult.push(RequiredFieldCheck('decisionDate', uwvDecision.decisionDate));
    validationResult.push(RequiredFieldCheck('wiaMonthlyWage', uwvDecision.wiaMonthlyWage));

    return validationResult;
  }
};
